module.exports = "<div class=\"btn-group pull-right\">\n    <button type=\"button\" class=\"btn btn-default\" style=\"margin-right: 1px;border-right-color: #ccc;\" ng-click=\"UndoCtrl.undo()\" ng-disabled=\"false\" title=\"{{ 'undo' | translate }}\"><i class=\"fa fa-undo\"></i></button>\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"UndoCtrl.redo()\" ng-disabled=\"false\" title=\"{{ 'redo' | translate }}\"><i class=\"fa fa-repeat\"></i></button>                          \n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/undo-redo/undo-redo.html
// module id = 271
// module chunks = 0